<div class="d-flex flex-column gap-3" data-testid="devices-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.devices.panel.title' | translate }}</h3>
    <p class="av-meta m-0">{{ 'backoffice.devices.panel.hint' | translate }}</p>
    <p class="av-meta m-0" data-testid="devices-actions-note">
      {{ 'backoffice.devices.panel.actions_note' | translate }}
    </p>

    <a
      class="av-btn text-decoration-none align-self-start"
      [routerLink]="['/devices']"
      [queryParams]="{ organization: organizationId() }"
      data-testid="device-estate-link"
    >
      <mat-icon aria-hidden="true">devices</mat-icon>
      <span>{{ 'backoffice.devices.panel.estate_link' | translate }}</span>
    </a>
  </div>

  @switch (facade.state()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.devices.error.title' | translate"
        [message]="'backoffice.devices.error.message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      <div class="d-flex flex-wrap align-items-center gap-2" data-testid="device-counts">
        <span class="av-meta">{{ 'backoffice.devices.panel.counts_title' | translate }}</span>
        @for (option of stateOptions; track option) {
          <av-status-chip
            [label]="(stateLabelKeys[option] | translate) + ': ' + countFor(option)"
            tone="neutral"
          ></av-status-chip>
        }
      </div>

      <div class="filter-row d-flex flex-wrap align-items-end gap-2">
        <label class="d-flex flex-column gap-1 flex-grow-1" for="device-search">
          <span class="av-meta">{{ 'backoffice.devices.filters.search' | translate }}</span>
          <input
            id="device-search"
            type="search"
            class="av-field w-100"
            [value]="facade.filters().search"
            [matTooltip]="'backoffice.devices.filters.search_hint' | translate"
            (change)="search($any($event.target).value)"
          />
        </label>

        <label class="d-flex flex-column gap-1" for="device-state">
          <span class="av-meta">{{ 'backoffice.devices.filters.state' | translate }}</span>
          <select
            id="device-state"
            class="av-field"
            [value]="facade.filters().state"
            (change)="filterState($any($event.target).value)"
          >
            <option value="">{{ 'backoffice.devices.filters.any_state' | translate }}</option>
            @for (option of stateOptions; track option) {
              <option [value]="option">{{ stateLabelKeys[option] | translate }}</option>
            }
          </select>
        </label>

        @if (facade.hasActiveFilters()) {
          <button type="button" class="av-btn" (click)="clearFilters()">
            {{ 'backoffice.devices.filters.clear' | translate }}
          </button>
        }
      </div>

      <p class="av-meta m-0" data-testid="device-inactive-rule">
        {{ 'backoffice.devices.estate.inactive_rule' | translate }}
      </p>

      @if (facade.isEmpty()) {
        <av-empty-state
          icon="devices"
          [title]="
            (facade.hasActiveFilters()
              ? 'backoffice.devices.empty.filtered_title'
              : 'backoffice.devices.empty.title'
            ) | translate
          "
          [message]="
            (facade.hasActiveFilters()
              ? 'backoffice.devices.empty.filtered_message'
              : 'backoffice.devices.empty.message'
            ) | translate
          "
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="device-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.devices.table.device' | translate }}</th>
                <th scope="col">{{ 'backoffice.devices.table.state' | translate }}</th>
                <th scope="col">{{ 'backoffice.devices.table.last_seen' | translate }}</th>
                <th scope="col">{{ 'backoffice.devices.panel.table.agent' | translate }}</th>
                <th scope="col">{{ 'backoffice.devices.panel.table.licence' | translate }}</th>
                <th scope="col">{{ 'backoffice.devices.panel.table.enrolled' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (device of facade.devices(); track device.id) {
                <tr>
                  <td>
                    <div class="d-flex flex-column">
                      <span class="cell-strong">{{ device.displayName }}</span>
                      <span class="av-source">{{ device.azureADDeviceId || unresolved }}</span>
                    </div>
                  </td>

                  <td>
                    <av-status-chip
                      [label]="device.stateLabelKey | translate"
                      [tone]="device.stateTone"
                    ></av-status-chip>
                  </td>

                  <td class="cell-muted">
                    @if (device.hasNeverCheckedIn) {
                      {{ 'backoffice.devices.table.never_seen' | translate }}
                    } @else {
                      {{ device.last_seen_at | date: dateTimeFormat }}
                    }
                  </td>

                  <td class="cell-muted">
                    {{
                      (device.is_provisioned
                        ? 'backoffice.devices.panel.provisioned'
                        : 'backoffice.devices.panel.not_provisioned'
                      ) | translate
                    }}
                  </td>

                  <td class="cell-muted">{{ device.licenceStateLabelKey | translate }}</td>

                  <td class="cell-muted">
                    {{ device.created_at ? (device.created_at | date: dateTimeFormat) : unresolved }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.page()"
          [pageSize]="facade.pageSize()"
          [total]="facade.total()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.devices.panel.loading_title' | translate"
        [message]="'backoffice.devices.panel.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
